import { render } from "./QuoteView.vue?vue&type=template&id=081bc809&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"

import "./QuoteView.vue?vue&type=style&index=0&id=081bc809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081bc809"]])

export default __exports__